const storageKeys = {
	'pins' : 'pins',
	'filter': 'sortenfinder-filter',
}

function getKey(key) {
	return storageKeys[key] || key
}

function get(key) {
	let data = null
	try {
		data = JSON.parse(window.localStorage.getItem(getKey(key)))
	} catch(e) {
		console.error(e)
	}
	return  data
}

function set(key, value) {
	try {
		window.localStorage.setItem(getKey(key), JSON.stringify(value))
	} catch(e) {
		console.error(e)
	}
}

function remove(key) {
	window.localStorage.removeItem(getKey(key))
}




module.exports = {
	get,
	set,
	remove
}
